import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ScholarshipPaymentActions from './scholarship-payment.actions';
import { ScholarshipPaymentService } from '../../services/scholarship-payment.service';
import { Router } from '@angular/router';

@Injectable()
export class ScholarshipPaymentEffects {
  loadScholarshipPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipPaymentActions.loadScholarshipPayment),
      exhaustMap(({ id }) =>
        this.scholarshipPaymentService.getScholarshipPayment(id).pipe(
          map((data) => {
            console.log('data from effect', data);
            return ScholarshipPaymentActions.loadScholarshipPaymentSuccess({
              scholarshipPayment: data,
            });
          }),
          catchError((error) =>
            of(
              ScholarshipPaymentActions.loadScholarshipPaymentFailure({
                error,
              })
            )
          )
        )
      )
    )
  );

  addScholarshipPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipPaymentActions.addScholarshipPayment),
      concatMap(({ newScholarshipPayment }) =>
        this.scholarshipPaymentService
          .createScholarshipPayment(newScholarshipPayment)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ScholarshipPaymentActions.addScholarshipPaymentSuccess({
                newScholarshipPayment: data,
              });
            }),
            catchError((error) =>
              of(
                ScholarshipPaymentActions.addScholarshipPaymentFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateScholarshipPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipPaymentActions.updateScholarshipPayment),
      concatMap(({ updateScholarshipPayment }) =>
        this.scholarshipPaymentService
          .updateScholarshipPayment(updateScholarshipPayment)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ScholarshipPaymentActions.updateScholarshipPaymentSuccess({
                updateScholarshipPayment: data,
              });
            }),
            catchError((error) =>
              of(
                ScholarshipPaymentActions.updateScholarshipPaymentFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  // updateSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ScholarshipPaymentActions.updateScholarshipPaymentSuccess),
  // 			tap(() => {
  // 				console.log('navigate');
  // 				return this.router.navigate([ '/scholarship' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  removeScholarshipPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipPaymentActions.removeScholarshipPayment),
      map((action) => action.ids),
      concatMap((ids) =>
        this.scholarshipPaymentService.deleteScholarshipPayment(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ScholarshipPaymentActions.removeScholarshipPaymentSuccess({
              ids,
            });
          }),
          catchError((error) =>
            of(
              ScholarshipPaymentActions.updateScholarshipPaymentFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private scholarshipPaymentService: ScholarshipPaymentService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
